<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-12">
    <cf-verify-account-cta v-if="!isGuestReceipt" />

    <h3 class="cf-title cf-title--3">
      {{ title }}
    </h3>

    <div class="cf-flex cf-flex--column cf-flex--gap-16">
      <div class="cf-flex cf-flex--column cf-flex--gap-8">
        <h4 class="cf-title cf-tile--4">
          {{ receipt.guestName }}
        </h4>

        <p
          v-if="receipt.phoneNumber"
          class="cf-subtitle cf-subtitle--2"
        >
          {{ $phone(receipt.phoneNumber) }}
        </p>

        <p
          v-if="receipt.email"
          class="cf-subtitle cf-subtitle--2"
        >
          {{ receipt.email }}
        </p>
      </div>

      <cf-your-payment-details
        v-if="!isGuestReceipt && !isItemPricingHidden"
        :order="receipt"
        :payment="yourPayment"
      />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfVerifyAccountCta from '@/view/components/globals/cf-verify-account-cta/index.vue';
  import CfYourPaymentDetails from '@/view/components/globals/cf-your-payment-details/index.vue';


  export default {
    name: 'ReceiptContactAndPaymentInfo',

    components: {
      CfVerifyAccountCta,
      CfYourPaymentDetails
    },

    props: {
      receipt: {
        type: Object,
        required: true
      },

      isGuestReceipt: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters('receipt', ['yourPayment']),

      isItemPricingHidden() {
        return this.receipt.store?.features?.HidePrices;
      },

      title() {
        return this.isItemPricingHidden
          ? 'Contact Info:'
          : 'Contact & Payment Info:';
      }
    }
  };
</script>
